const Loader = () => {
    return(
        <div id="preloader">
            <div className="bar-container">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>
            <h1>Loading...</h1>
        </div>
    )
}

export default Loader